import { useTranslation } from 'react-i18next'
import { Button } from '@/components/v2/ui/Button'
import { SegmentRuleRow } from './SegmentRuleRow'
import type { ProductSegmentRule, SegmentCondition } from './segmentPresets'

interface Props {
  rule: ProductSegmentRule
  /** Stable per-condition keys (parallel list, same length/order as rule.conditions). */
  itemKeys: number[]
  onAdd: () => void
  onChange: (idx: number, c: SegmentCondition) => void
  onRemove: (idx: number) => void
}

/** Condition list + "Add condition" button for the SegmentRuleBuilder. */
export function SegmentConditionList({ rule, itemKeys, onAdd, onChange, onRemove }: Props) {
  const { t } = useTranslation()

  return (
    <>
      <div className="flex flex-col gap-2 my-3">
        {rule.conditions.map((c, i) => (
          <SegmentRuleRow
            key={itemKeys[i] ?? i}
            condition={c}
            onChange={(updated) => onChange(i, updated)}
            onRemove={() => onRemove(i)}
          />
        ))}
      </div>

      <Button
        data-testid="rule-add"
        variant="outline"
        size="sm"
        onClick={onAdd}
        className="self-start"
      >
        {t('productSegments.builder.addCondition')}
      </Button>
    </>
  )
}

SegmentConditionList.displayName = 'SegmentConditionList'
